import './burger'
import './slider'
import './map'
import './filter'
import './search'
import './form-validator'



// WEBPACK FOOTER //
// ./src/js/main.js